import { API_CALL } from 'actions/actionConstants'
import type { AppAction } from 'actions/types/ActionTypes'
import { FETCH_MERCHANDISE_BRANDS_LIST } from 'actions/apiActionConstants'
import getObjectKey from 'lib/object/getObjectKey'
import getMerchandiseBrandsList from 'api/merchandise/getMerchandiseBrandsList'

function fetchMerchandiseBrandsList(filters: App.MerchandiseBrandFilters): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    const key = getObjectKey(filters)
    if (state.merchandise.merchandiseBrandLists[key] ||
      state.merchandise.fetchingMerchandiseBrandLists[key] ||
      state.merchandise.merchandiseBrandListErrors[key]
    ) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_MERCHANDISE_BRANDS_LIST,
      request: () => getMerchandiseBrandsList(filters),
      key,
    })
  }
}

export default fetchMerchandiseBrandsList
